import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { usePaths } from '../../../routes/routesHelper';
import { getRandomString } from '../../../utils';
import AutoTooltipedText from '../AutoTooltipedText/index';
import { Tab, TabsWrapper, Wrapper } from './style';
import { Props, TabLinkProps } from './types';

const Tabs = ({ items, location, extraRight, rightContent, dataTestId }: Props) => {
  const { statisticsPath } = usePaths();
  const { pathname } = location;
  const currentRoute =
    pathname[pathname.length - 1] === '/' ? pathname.substring(0, pathname.length - 1) : pathname;

  const CustomLink = ({ disabled, children, href }: TabLinkProps) => {
    if (disabled) return <>{children}</>;

    return <Link to={href}>{children}</Link>;
  };

  return (
    <Wrapper>
      <TabsWrapper extraRight={extraRight} data-test-id={dataTestId}>
        {items.map((item) => {
          if (item.isDashboard) {
            return (
              <Tab
                isActive={statisticsPath() !== currentRoute}
                disabled={!!item.disabled}
                key={getRandomString()}>
                <CustomLink
                  data-test-id="link-dashboard"
                  disabled={!!item.disabled}
                  href={item.href}>
                  {item.label}
                </CustomLink>
              </Tab>
            );
          }

          return (
            <Tab
              isActive={item.href === currentRoute}
              disabled={!!item.disabled}
              key={getRandomString()}>
              <CustomLink disabled={!!item.disabled} href={item.href}>
                <AutoTooltipedText text={item.label} />
              </CustomLink>
            </Tab>
          );
        })}
      </TabsWrapper>
      {rightContent}
    </Wrapper>
  );
};

export default withRouter(Tabs);
